<template>
  <div class="yjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            业绩趋势分析
            <el-form :inline="true" size="small" :model="searchForm" style="float: right;">
              <el-form-item label="组织">
                <el-select v-model="searchForm.group" style="width: 120px" filterable clearable>
                  <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name" :value="item.groupid" />
                </el-select>
              </el-form-item>
              <el-form-item label="选择月份">
                <el-date-picker
                  v-model="searchForm.lineTime"
                  format="yyyy年MM月"
                  value-format="yyyy-MM"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  :clearable="false"
                  type="monthrange">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button :loading="lineLoading" icon="el-icon-s-data" type="primary" @click="getLineData">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <el-row>
              <el-col v-loading="lineLoading" :span="24">
                <GraphicsChart id="line" :option="lineOptions"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="tcf-row" style="padding-top:0;">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            业绩对比统计分析
            <el-form :inline="true" size="small" :model="searchForm" style="float: right;">
              <el-form-item label="组织">
                <el-select v-model="searchForm.group2" style="width: 120px" filterable clearable>
                  <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name" :value="item.groupid" />
                </el-select>
              </el-form-item>
              <el-form-item label="选择月份">
                <el-date-picker
                  v-model="searchForm.columnTime"
                  format="yyyy年MM月"
                  value-format="yyyy-MM"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  :clearable="false"
                  type="monthrange">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button :loading="columnLoading" icon="el-icon-s-data" type="primary" @click="getColumnData">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <el-row>
              <el-col v-loading="columnLoading" :span="24">
                <GraphicsChart id="column" :option="columnOptions"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="tcf-row" style="padding-top:0;">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            <div>
              经销商业绩对比统计分析
            </div>
            <el-form ref="form" :inline="true" size="small" :model="searchForm2" style="float: right;" :rules="rules" @submit.native.prevent>
              <el-form-item label="年份/月份">
                <el-button-group>
                  <el-button :type="searchForm2.yearMonth===0?'primary':''" size="small" @click="updataYearMonth(0)">年份</el-button>
                  <el-button :type="searchForm2.yearMonth===1?'primary':''" size="small" @click="updataYearMonth(1)">月份</el-button>
                </el-button-group>
              </el-form-item>
              <el-form-item v-if="searchForm2.yearMonth === 0" label="选择年份" prop="year">
                <el-date-picker
                  v-model="searchForm2.year"
                  type="year"
                  placeholder="选择年份">
                </el-date-picker>
              </el-form-item>
              <el-form-item  v-if="searchForm2.yearMonth === 1" label="选择月份" prop="month">
                <el-date-picker
                  v-model="searchForm2.month"
                  type="month"
                  placeholder="选择月份">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="经销商" prop="dealer">
                <el-select v-model="searchForm2.dealer" clearable multiple placeholder="请选择经销商" filterable style="width:495px;">
                  <el-option
                    v-for="item in dealerList"
                    :key="item.dealer_id"
                    :label="item.all_name"
                    :value="item.dealer_id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="组织">
                <el-select v-model="searchForm2.groupid" style="width: 120px" filterable clearable>
                  <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name" :value="item.groupid" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :loading="dealerLoading" icon="el-icon-s-data" type="primary" @click="getDealerData('form')">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <el-row>
              <el-col v-loading="dealerLoading" :span="24">
                <GraphicsChart id="dealerOption" :option="dealerOption"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import GraphicsChart from '../../../components/Charts/GraphicsChart'
import { dateFormat } from '@/utils/index'
import { getPerformanceReport, getLastYearPerformanceReport, getOrderReportDealer, getDelerPerformanceComparison } from '@/api/tj'
import { getGroupReport } from '@/api/pub'
export default {
  name: 'yjfx',
  components: {
    GraphicsChart
  },
  data() {
    return {
      dealerOption: {
        title: false,
        exporting: {
          enabled: true
        },
        credits: {
          enabled: false
        }
      },
      dealerList: [],
      dealerLoading: false,
      searchForm2: {
        yearMonth: 0,
        groupid: null,
        year: null,
        month: null,
        dealer: []
      },
      rules: {
        dealer: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        year: [{ required: true, message: '请选择年份', trigger: 'change' }],
        month: [{ required: true, message: '请选择月份', trigger: 'change' }]
      },
      groupList: [],
      searchForm: {
        lineTime: [],
        columnTime: [],
        group: null,
        group2: null
      },
      lineOptions: {
        title: false,
        credits: {
          enabled: false
        }
      },
      columnOptions: {
        title: false,
        credits: {
          enabled: false
        }
      },
      lineLoading: false,
      columnLoading: false,
      isFirst: true
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getGroupReport().then(response => {
      const arr = []
      for (const item of response.data) {
        if (item.nature === 0) {
          arr.push(item)
        }
      }
      this.groupList = arr
      // 经销商
      getOrderReportDealer({ userid: this.user.dUserid, role: this.user.role, groupid: this.user.dGroupid }).then(response => {
        this.dealerList = response.data
      })
    })
    const end = new Date()
    const start = new Date()
    start.setMonth(start.getMonth() - 11)
    const startTime = dateFormat('YYYY-mm', start)
    const endTime = dateFormat('YYYY-mm', end)
    this.searchForm.lineTime.push(startTime)
    this.searchForm.lineTime.push(endTime)
    this.searchForm.columnTime.push(startTime)
    this.searchForm.columnTime.push(endTime)
    this.getLineData()
  },
  methods: {
    getDealerData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let thisDate = null
          let lastDate = null
          if (this.searchForm2.yearMonth === 0) {
            thisDate = this.searchForm2.year.getFullYear()
            lastDate = this.searchForm2.year.getFullYear() - 1
          } else {
            var year = this.searchForm2.month.getFullYear() // 得到年份
            var month = this.searchForm2.month.getMonth() // 得到月份
            month = month + 1
            if (month < 10) {
              month = '0' + month
            }
            thisDate = year + '-' + month
            lastDate = (year - 1) + '-' + month
          }
          const data = {
            thisDate: thisDate,
            lastDate: lastDate,
            groupid: this.searchForm2.groupid,
            ids: this.searchForm2.dealer.join(','),
            userid: this.user.dUserid
          }
          getDelerPerformanceComparison(data).then(response => {
            const dealerNames = []
            const downMoney = []
            const lastDownMoney = []
            for (const item of response.data) {
              dealerNames.push(item.name)
              downMoney.push(item.downMoney)
              lastDownMoney.push(item.lastDownMoney)
            }
            const chart = {
              lang: {
                printChart: '打印图表',
                downloadPNG: '下载JPEG 图片',
                downloadJPEG: '下载JPEG文档',
                downloadPDF: '下载PDF 图片',
                downloadSVG: '下载SVG 矢量图',
                contextButtonTitle: '下载图片'
              },
              chart: {
                type: 'column'
              },
              title: false,
              credits: {
                enabled: false
              },
              xAxis: {
                categories: dealerNames,
                crosshair: true
              },
              yAxis: {
                min: 0,
                title: {
                  text: '金额'
                }
              },
              tooltip: {
                // head + 每个 point + footer 拼接成完整的 table
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}下单金额: </td>' +
                  '<td style="padding:0"><b>{point.y:.1f} 元</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
              },
              plotOptions: {
                column: {
                  borderWidth: 0,
                  dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                  }
                }
              },
              series: [
                { name: lastDate, data: lastDownMoney },
                { name: thisDate, data: downMoney }]
            }
            this.dealerOption = chart
          })
        } else {
          return false
        }
      })
    },
    updataYearMonth(val) {
      this.searchForm2.yearMonth = val
    },
    getLineData() {
      if (this.isFirst) {
        this.columnLoading = true
      }
      this.lineLoading = true
      getPerformanceReport({ userid: this.user.dUserid, startTime: this.searchForm.lineTime[0], endTime: this.searchForm.lineTime[1], group: this.searchForm.group }).then(response => {
        if (this.isFirst) {
          this.getColumnData()
          this.isFirst = false
        }
        const chart = {
          chart: {
            type: 'spline',
            inverted: false
          },
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          title: false,
          yAxis: {
            title: {
              text: '下单金额'
            }
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },
          xAxis: {
            categories: response.data.months,
            crosshair: true,
            title: {
              text: '月份'
            }
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: [response.data.lineData]
        }
        this.lineOptions = chart
        this.lineLoading = false
      }).catch(() => {
        this.lineLoading = false
      })
    },
    getColumnData() {
      this.columnLoading = true
      getLastYearPerformanceReport({ userid: this.user.dUserid, startTime: this.searchForm.columnTime[0], endTime: this.searchForm.columnTime[1], group: this.searchForm.group2 }).then(response => {
        const chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          chart: {
            type: 'column'
          },
          title: false,
          xAxis: {
            categories: response.data.months,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: '下单金额'
            }
          },
          tooltip: {
            // head + 每个 point + footer 拼接成完整的 table
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f} 元</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: response.data.columnData
        }
        this.columnOptions = chart
        this.columnLoading = false
      }).catch(() => {
        this.columnLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
